import React, { FC, ReactElement, useEffect } from 'react'
import { ManageQueues as ManageQueuesLanguage } from '../../../../../i18n'
import CLanguageHandler from '../../../../NonReact/Languages/LanguageHandler'
import { StandardContexts } from '../../../../React/Common/Components/StandardContexts'
import { ModalContextProvider } from '../../../../React/Common/Contexts/ModalContext'
import { ManageQueues } from '../../../../React/ManageQueues/Main/ManageQueues'
import { clearModalHelpTopic, setModalHelpTopicID } from '../../../../React/Common/Utils/HelpPortal'
import { DocTopic } from '../../../../React/Common/Constants/Documentation'

/**
 * <p>Queue management page body.
 *
 * The same ManageQueues content the legacy ManageQueuesModal renders, without the modal dialog
 * chrome, for use as a routed v2 portal page (/CCS/App/v2/queueManagement). ManageQueues needs the
 * ModalContext and the standard user/message contexts, so both wrap it here just as the modal does;
 * closeModal is a no-op because there is no dialog to close in page mode.
 *
 * @returns The queue management content wrapped in the contexts ManageQueues depends on.
 */
export const QueueManagement: FC = (): ReactElement => {
    // Top-level component, so load the language bundle directly rather than via context.
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle(ManageQueuesLanguage.NAME)

    useEffect((): (() => void) => {
        setModalHelpTopicID(DocTopic.MANAGE_QUEUES)

        return (): void => {
            clearModalHelpTopic()
        }
    }, [])

    return (
        <ModalContextProvider
            modalInput={{
                closeModal: (): void => {}
            }}
        >
            <StandardContexts>
                {/* admin-list-container gives the standard admin-page outer padding and, via its
                    .dark-mode / .react-router:has() rules, the dark-mode background — ManageQueues
                    was built for a modal, so on a page it needs this wrapper to be themed and padded. */}
                <div className='admin-list-container'>
                    <ManageQueues pageMode />
                </div>
            </StandardContexts>
        </ModalContextProvider>
    )
}
